import '@babel/polyfill';

(async () => {
  await import(/* webpackChunkName: "acquisition-main" */ '../pages/how_tomorrow_works/acquisition/main');
})();
